import ArrowBackIcon from '@mui/icons-material/ArrowBack';
import { Grid, Typography, useMediaQuery, useTheme } from '@mui/material';
import React from 'react';
import { useNavigate } from 'react-router-dom';
import { CustomButton } from '../../../layout/styledcomponents/CustomButton';
import BookingCapForm from '../../components/BookingCaps/BookingCapForm';

const AddBookingCapPage = () => {
    const isMobile = useMediaQuery('(max-width: 770px)');
    const isIpad = useMediaQuery('(max-width: 1200px)');
    const navigate = useNavigate();
    const theme = useTheme();

    const handleBackButton = () => {
        navigate(`/bookingCaps`);
    };

    return (
        <Grid
            sx={{
                width: '100%',
                height: isMobile ? '100%' : '95%',
                justifyContent: 'left',
                alignItems: 'center',
            }}
        >
            <BookingCapForm />
            <CustomButton
                onClick={handleBackButton}
                color='primary'
                sx={{
                    marginLeft: '-18px',
                    display: isMobile || isIpad ? 'none' : 'flex', // Hide on mobile
                    '&:hover': {
                        cursor: 'pointer',
                        color: theme.palette.textAccent.main,
                        backgroundColor: 'transparent',
                        background: 'none',
                    },
                }}
            >
                <ArrowBackIcon />
                <Typography
                    sx={{
                        fontSize: '12px',
                        paddingLeft: '5px',
                    }}
                >
                    Back to list
                </Typography>
            </CustomButton>
        </Grid>
    );
};

export default AddBookingCapPage;
